import { graphql } from "../generated";

export const DELETE_ACCOUNT = graphql(`
  mutation DeleteAccount {
    deleteAccount {
      token
    }
  }
`);
